








































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Box from '../components/Box.vue'
import api from "../../api/index"

@Component({
  components: {
    'box': Box
  }
})

export default class LostPassword extends Vue {
  email = ""
  emailSubmitted = ""
  confirmationEmailSend = false
  apiError = false

  get formIsValid() {
    const emailIsValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
    if (emailIsValid) {
      return true
    } else {
      return false
    }
  }

  async mounted() {
    await api.init()
  }

  async askNewPassword() {
    if (this.formIsValid) {
      const params = {
        email: this.email,
      }
      try {
        const res = await api.post("bo/password", params)
        this.apiError = false
        this.confirmationEmailSend = true
      } catch (e) {
        if (e.response.status !== 201) {
            console.log(e.response.status)
            this.apiError = true
            this.emailSubmitted = this.email
          }
      }
    }  
  }
}
